import React, { createContext, useState } from "react";

export const LocalizationContext = createContext([]);

export const LocalizationContextProvider = props => {
    const [localizationState, setLocalizationState] = useState(null);

    return (
        <LocalizationContext.Provider value={[localizationState, setLocalizationState]}>
            {props.children}
        </LocalizationContext.Provider>
    );
};